import React, { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../../disaster/components/collapseAbleTable/CollapseableTable";
import useModuleData from "../../../disaster/hooks/useFetchItems";
import useCreateAttribute from "../../../disaster/hooks/useCreateAttribute";
import useModalHandlers from "../../../disaster/hooks/useModalHandler";
import useChangeHandler from "../../../disaster/hooks/useChangeHandler";
import useGetAttributes from "../../../disaster/hooks/useGetAttributes";
import useDeleteItem from "../../../disaster/hooks/useDeleteItem";
import { Table } from "antd";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import UseUpdate from "../../../disaster/hooks/UseUpdate";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { getAllColumns } from "./AllColumnsData";

const moduleNames = [
  "Business Interests",
  "Business Assets",
  "Financial Statements",
  "Tax Returns",
  "Partnership Agreements",
  "Client Lists",
  "Intellectual Property",
];

export default function FormInputFields() {
  const [loading, setLoading] = useState(false);
  const [moduleName, setModuleName] = useState("Business Interests");
  const [formData, setFormData] = useState(null); // State for DisabilityFormCreator
  const [attributesData, setAttributesData] = useState(null);
  const history = useHistory();

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useModuleData(moduleNames, setLoading);

  const tableDataObj = {
    "Business Interests": tableData.businessInterestsData,
  };

  const { attributes, disasterAttribute } = useGetAttributes(
    moduleNames,
    setLoading
  );

  console.log("Attributes Data:", attributes);
  console.log("Disaster Attributes", disasterAttribute);

  //   const { showModal, updateModal, viewModal, handelCloseModal } = useModalHandlers(
  //     attributes,
  //     setModalTitle,
  //     setModuleName,
  //     setIsModalVisible,
  //     setModalFormData, // Using the new state for modal form data
  //     setAttributesData,
  //   )
  console.log("fotrmrmtmtmt", formData, tableData);
  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { updateRecord } = UseUpdate(
    moduleName,
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  //   const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord)

  //   const { handleChange, handleItemsInfoSelect } = useChangeHandler(setModalFormData)
  console.log("Modal form data", formData);

  const Tables = [
    { title: "Business Assets", key: 1 },
    { title: "Financial Statements", key: 2 },
    { title: "Tax Returns", key: 3 },
    { title: "Partnership Agreements", key: 4 },
    { title: "Client Lists", key: 5 },
    { title: "Intellectual Property", key: 6 },
  ];

  const AddContact = () => {
    history.push("/client/plan");
  };
  const AddDocument = () => {
    history.push("/organizer/important-document");
  };

  const cleanedAttributes = Array.isArray(attributes)
    ? attributes
        .filter(
          (item) => item !== null && typeof item === "object" && item.attributes
        )
        .reduce((acc, curr) => {
          acc[curr.name] = curr.attributes;
          return acc;
        }, {})
    : {};

  return (
    <div>
      {disasterAttribute && (
  <>
    

    <DisabilityFormCreator
      data={disasterAttribute}
      values={disasterAttributeData}
      setSubmitBody={setFormData}
    />
    {console.log("Divorce Form Data:", disasterAttributeData)}
    
    <div className="handle-submit-button-container">
      <button
        className="submit-button"
        onClick={async () => {
          if (toUpdate) {
            await updateRecord();
          } else {
            if (formData && Object.keys(formData).length > 0) {
              await createAttributes();
            }
          }
        }}
      >
        {toUpdate ? "Update" : "Submit"}
      </button>
    </div>
  </>
)}


      <NewLoader isLoading={loading} />
    </div>
  );
}
